// extracted by mini-css-extract-plugin
export default {"cls1":"WYY5jdohbkDD4scCS4n0","cls2":"aQ9A_OXpVBZ3PC_QWH7k WYY5jdohbkDD4scCS4n0","bookingAppRedesign":"Rt8fZeb3T_uAWPAZKtcJ"};